"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rect_1 = require("@reach/rect");
const react_1 = require("react");
const react_slider_1 = __importDefault(require("react-slider"));
const Box_1 = require("../Box");
function Slider({ ariaLabel, ariaValuetext, isDisabled, step = 1, min = 0, max = 100, value, defaultValue, onBeforeChange, onChange, onAfterChange, }) {
    const ref = react_1.useRef(null);
    const outerRef = react_1.useRef(null);
    const rect = rect_1.useRect(outerRef);
    const outerWidth = rect === null || rect === void 0 ? void 0 : rect.width;
    react_1.useLayoutEffect(() => {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.resize();
    }, [outerWidth]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ height: "1rem", ref: outerRef }, { children: jsx_runtime_1.jsx(react_slider_1.default, { ariaLabel: ariaLabel, ariaValuetext: ariaValuetext, disabled: isDisabled, min: min, max: max, step: step, value: value, defaultValue: defaultValue, renderTrack: Track, renderThumb: Thumb, onBeforeChange: onBeforeChange, onChange: onChange, onAfterChange: onAfterChange, ref: ref }, void 0) }), void 0));
}
exports.Slider = Slider;
function Thumb(props) {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ height: "1rem", width: "1rem", borderRadius: "50%", backgroundColor: "accent", boxShadow: 2, style: { cursor: 'grab' }, top: 0, bottom: 0 }, props), void 0));
}
function Track(props) {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ backgroundColor: "muted", height: "0.35rem", position: "absolute", top: "0.325rem" }, props), void 0));
}
exports.default = Slider;
//# sourceMappingURL=index.js.map